import { configure } from 'mobx';
import { companyStore } from './companyStore';
import { vacancyStore } from './vacancyStore';
import { interviewStore } from './interviewStore';
import { personalDataStore } from './personalDataStore';
import { mediaStreamStore } from './mediaStreamStore';
import { chatStore } from './chatStore';

configure({
  enforceActions: 'always',
  computedRequiresReaction: true,
  reactionRequiresObservable: true,
  observableRequiresReaction: true,
  disableErrorBoundaries: true
});

export const useStores = () => {
  return {
    interviewStore,
    personalDataStore,
    mediaStreamStore,
    companyStore,
    vacancyStore,
    chatStore
  };
};
